import controller from './client-admin-controller';
import template from './client-admin.html';

const ClientAdminComponent = {
    bindings: {
        clientList: '<',
        groupList: '<',
        facilityList: '<',
        campusList: '<',
        surveyTemplateList: '<',
        userList: '<'
    },
    controller,
    template,
};

export default ClientAdminComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/client-admin-component.js